import { Icon } from "../icons/Icon";

export interface CapabilityListGroup { title: string; items: { id: string; label: string; desc: string; granted: boolean; /** a short qualifier after the label, e.g. "Whole workspace" */ tag?: string }[]; }

/** What a role allows, read-only: a check or a dash per capability. Changing it happens on the role, in edit mode, never here. */
export function CapabilityList({ groups }: { groups: CapabilityListGroup[] }) {
  return (
    <div className="ob-caplist">
      {groups.map((g) => (
        <section key={g.title} className="ob-caplist__group" aria-label={g.title}>
          <h3 className="ob-caplist__title">{g.title}</h3>
          <ul className="ob-caplist__rows">
            {g.items.map((c) => (
              <li key={c.id} className={`ob-caplist__row${c.granted ? "" : " ob-caplist__row--off"}`}>
                {c.granted ? <Icon name="check" size="sm" /> : <span className="ob-caplist__dash" aria-hidden="true" />}
                <span className="ob-caplist__text"><span className="ob-caplist__label">{c.label}{c.tag && <span className="ob-caplist__tag"> · {c.tag}</span>}<span className="ob-sr-only">{c.granted ? ": allowed" : ": not allowed"}</span></span><span className="ob-caplist__desc">{c.desc}</span></span>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}
